import initReactApp from 'dpl/util/initReactApp';
import BreedLocationInfo from 'dpl/containers/BreedLocationInfo';
import BreederProfileEmptyResultsContainer from 'dpl/containers/BreederProfile/Index/BreederProfileEmptyResultsContainer';
import BreederProfileSuggestedBreedsListContainer from 'dpl/containers/BreederProfile/Index/BreederProfileSuggestedBreedsListContainer';
import NewsletterFormContainer from 'dpl/containers/NewsletterFormContainer';
import PuppyResultsTabbedLayout from 'dpl/puppy_search_results/components/TabbedLayout';
import BreederResultsBreedDescriptionModal from 'dpl/breeder_search_results/components/BreedDescriptionModal';
import BreederResultsBreedDescription from 'dpl/breeder_search_results/components/BreedDescription';
import BreederProfilePhotoAlbumContainer from 'dpl/containers/BreederProfile/Show/BreederProfilePhotoAlbumContainer';
import ParentModal from 'dpl/dog_modals/parent_modal/components/ParentModal';
import LitterModal from 'dpl/dog_modals/litter_modal/components/LitterModal';
import PageHeroLocation from 'dpl/puppy_search_results/components/PageHeroLocation';

initReactApp({
  BreederProfileEmptyResultsContainer,
  BreederProfileSuggestedBreedsListContainer,
  NewsletterFormContainer,
  PuppyResultsTabbedLayout,
  BreederProfilePhotoAlbumContainer,
  ParentModal,
  LitterModal,
  BreederResultsBreedDescription,
  BreederResultsBreedDescriptionModal,
  BreedLocationInfo,
  PageHeroLocation
});
